"use client";

import { logEvent } from "firebase/analytics";

import type { AnalyticsProps } from "./Analytics.types";

export const Analytics = ({
  component: Component,
  onClick,
  onChange,
  analytics,
  events,
  children,
  ...props
}: AnalyticsProps) => {
  const handleOnChange = () => {
    if (analytics && events?.name) {
      logEvent(analytics, events?.name || "", events?.params);
    }
    if (onChange) {
      onChange();
    } else if (onClick) {
      onClick();
    }
  };

  return onChange ? (
    <Component {...props} onChange={handleOnChange}>
      {children}
    </Component>
  ) : (
    <Component {...props} onClick={handleOnChange}>
      {children}
    </Component>
  );
};
